import * as React from 'react';
import { Box } from '@mui/material';
import { AlertBanner, AlertBannerProps } from '@c42/component-library';

interface FormValidationMessageProps {
  dataTest?: string;
  message: string | null;
  type?: AlertBannerProps['type'];
}

const FormValidationMessage: React.FC<FormValidationMessageProps> = ({
  dataTest,
  message,
  type = 'error',
}) => {
  if (message) {
    return (
      <Box my={1}>
        <AlertBanner data-test={dataTest} type={type} variant="standard">
          {message}
        </AlertBanner>
      </Box>
    );
  }
  return <Box data-test="no-message" height={50} my={1} />;
};

export default FormValidationMessage;
